module.exports = __webpack_public_path__ + "static/img/A2E_training_Ivory-Coast_2017.7c16edb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_training_Ivory-Coast_2017.jpg
// module id = aW+V
// module chunks = 0